import React from 'react'
import styled from 'styled-components'
import { AboutBanner, AboutHead, MeetTeam } from '../../components/comp'

const About = () => {
  return (
    <AboutWrapper>
      <AboutBanner />
      <AboutHead />
      <MeetTeam />
    </AboutWrapper>
  )
}

const AboutWrapper = styled.section`
  
`

export default About